import { isConfirmResponse } from 'core/api/api.typesGuards';
import { commandGetSuccess,startCommand } from 'core/redux/actions/command/commandActions';
import { clearConfirmation,showConfirmation } from 'core/redux/actions/confirmation/confirmationAction';
import { closeModalAction, refreshPageAction } from 'core/redux/actions/ui/uiActions';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { COMMAND_CANCEL_ID } from 'core/utilities/command/command';
import type { AnyAction,Middleware } from 'redux';
import { LOCATION_CHANGE } from 'redux-first-history';

const confirmationMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
  const state = store.getState() as ApplicationState;

  if (commandGetSuccess.match(action)) {
    if (isConfirmResponse(action.payload.response)) {
      store.dispatch(showConfirmation(action.payload.response.payload));
    }
  } else if (startCommand.match(action)) {
    if (action.payload.command.id === COMMAND_CANCEL_ID && state.ui.confirmation) {
      store.dispatch(clearConfirmation());
    }
  } else if (clearConfirmation.match(action)) {
    if (state.ui.confirmation) {
      store.dispatch(closeModalAction());
    }
  }

  if (refreshPageAction.match(action) || action.type === LOCATION_CHANGE) {
    if (state.ui.confirmation) {
      store.dispatch(clearConfirmation());
    }
  }

  next(action);
};

export default confirmationMiddleware;
